import { PastDue } from "./past-due.model";

export class User {
    id:number;
    username:string;
    firstname:string;
    lastname:string;
    pastDue:PastDue;
    hasParsInfo:boolean;

    constructor(data){
        this.id = data.person_pk;
        this.username = data.person_id;
        this.firstname = data.firstname;
        this.lastname = data.lastname;
        this.pastDue = data.casce_past_due ? new PastDue(data.casce_past_due) : null;
        this.hasParsInfo = data.user_has_pars_info? data.user_has_pars_info: false;
    }
}
